import * as echarts from 'echarts/core'
import {
  LineChart,
  BarChart,
  PieChart,
  GaugeChart,
  ScatterChart,
  EffectScatterChart,
  RadarChart,
  MapChart,
} from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  ToolboxComponent,
  DataZoomComponent,
  DatasetComponent,
  VisualMapComponent,
  MarkLineComponent,
  MarkPointComponent,
  GeoComponent,
  PolarComponent,
  RadarComponent,
  GraphicComponent,
} from 'echarts/components'
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers'

echarts.use([
  LineChart,
  BarChart,
  PieChart,
  GaugeChart,
  ScatterChart,
  EffectScatterChart,
  RadarChart,
  MapChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  ToolboxComponent,
  DataZoomComponent,
  DatasetComponent,
  VisualMapComponent,
  MarkLineComponent,
  MarkPointComponent,
  GeoComponent,
  PolarComponent,
  RadarComponent,
  GraphicComponent,
  CanvasRenderer,
  SVGRenderer,
])

export const echartsInstance = echarts
export default echarts
